export const PagerLargeSinglePageSize = 100;
